// Estado operacional (etapa_exibicao/status_exibicao/em_correcao_cliente) é
// projetado pela WebAPI a partir do estado técnico (codigo_etapa/codigo_sub_etapa).
// Este arquivo só lê o que a API já calculou — nunca reinterpreta os códigos.

export const obterEtapaExibicao = item => {
  if (!item) return undefined;
  return item.etapa_exibicao != null ? item.etapa_exibicao : item.etapa;
};

export const obterStatusEtapaExibicao = item => {
  if (!item) return undefined;
  return item.status_exibicao != null ? item.status_exibicao : item.sub_etapa;
};

export const obterValorOrdenacaoColuna = (item, chave) => {
  if (chave === 'etapa') return obterEtapaExibicao(item);
  if (chave === 'sub_etapa') return obterStatusEtapaExibicao(item);
  return item ? item[chave] : undefined;
};

const emAnaliseAtiva = item =>
  Boolean(item) &&
  item.status !== 0 &&
  item.codigo_etapa === 2 &&
  item.em_correcao_cliente !== true;

// Reprovada (3) ou bloqueada (5) só sai via reenvio para análise (alterar-status exige sub 1).
export const podeReenviarAnalise = item =>
  emAnaliseAtiva(item) &&
  (item.codigo_sub_etapa === 3 || item.codigo_sub_etapa === 5);

export const podeAlterarStatusDoc = item =>
  emAnaliseAtiva(item) &&
  (item.codigo_sub_etapa === 1 || podeReenviarAnalise(item));
